import { getItemFromStorageSimple, removeStorageItem, setStorageItem } from "./script"

export const TASKS_LIST_STATE_KEY = 'tasks_list_state'

/**
 * Load persisted tasks list filters, page, and sort from localStorage.
 * @returns {{ filters: object, currentpage: number, orderFilters: object|null }|null}
 */
export function getPersistedTasksListState() {
    try {
        const stored = getItemFromStorageSimple(TASKS_LIST_STATE_KEY)
        if (!stored || typeof stored !== 'object') {
            return null
        }

        return {
            filters: stored.filters && typeof stored.filters === 'object' ? stored.filters : {},
            currentpage: Number.isFinite(Number(stored.currentpage)) && Number(stored.currentpage) > 0
                ? Number(stored.currentpage)
                : 1,
            orderFilters: stored.orderFilters ?? null,
        }
    } catch (e) {
        return null
    }
}

/**
 * Persist tasks list filters, page, and sort for the current browser session (until login clears it).
 */
export function setPersistedTasksListState({ filters, currentpage, orderFilters }) {
    try {
        setStorageItem(TASKS_LIST_STATE_KEY, {
            filters: filters && typeof filters === 'object' ? filters : {},
            currentpage: Number.isFinite(Number(currentpage)) && Number(currentpage) > 0
                ? Number(currentpage)
                : 1,
            orderFilters: orderFilters ?? null,
        })
    } catch (e) {
        // localStorage may be unavailable; ignore
    }
}

/** Remove persisted tasks list state (used on login). */
export function clearPersistedTasksListState() {
    try {
        removeStorageItem(TASKS_LIST_STATE_KEY)
    } catch (e) {
        // ignore
    }
}
